import React, { useState } from "react";
import { X, Save } from "lucide-react";
import { useTranslation } from "react-i18next";
import telegramService from "../utils/telegram";

interface WeightModalProps {
  currentWeight: number;
  onSave: (weight: number) => void;
  onClose: () => void;
}

const WeightModal: React.FC<WeightModalProps> = ({
  currentWeight,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation();
  const [weight, setWeight] = useState(currentWeight.toString());

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const numWeight = parseFloat(weight);
    if (!isNaN(numWeight) && numWeight > 0) {
      telegramService.haptic("success");
      onSave(numWeight);
    } else {
      telegramService.haptic("error");
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200"
      style={{ backgroundColor: "var(--overlay)" }}
    >
      <div className="bg-surface rounded-2xl w-full max-w-xs p-6 shadow-2xl scale-in-95 animate-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-content-primary">{t("stats.logWeight")}</h3>
          <button
            onClick={onClose}
            className="text-content-tertiary hover:text-content-secondary transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex justify-center items-end gap-2">
            <input
              autoFocus
              type="number"
              step="0.1"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              className="text-5xl font-bold text-content-primary text-center bg-transparent border-b-2 border-line-strong focus:border-brand-400 outline-none w-32 py-2 transition-colors"
            />
            <span className="text-content-tertiary font-medium mb-4 text-lg">kg</span>
          </div>

          <button
            type="submit"
            className="w-full py-4 bg-brand-500 text-white rounded-xl font-bold text-lg shadow-lg hover:bg-brand-600 active:scale-95 transition-all flex items-center justify-center gap-2"
          >
            <Save size={20} />
            {t("common.save")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WeightModal;
